/**
 * Centralised regex patterns for the app.
 * Use this file for all validation patterns from now on.
 */

/** Valid email format */
export const EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

/** Indian mobile (10 digits, optional +91) */
export const MOBILE_INDIA = /^(\+91[\s-]?)?[6-9]\d{9}$/;

/** Indian PAN (e.g. ABCDE1234F) */
export const PAN_INDIA = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

/** Password: min 8 chars, at least one lowercase, one uppercase, one number and one special char */
export const PASSWORD_STRONG =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

/** Alphanumeric with spaces (e.g. names) */
export const ALPHA_SPACE = /^[a-zA-Z\s]+$/;

/** Alphabets only (no spaces, no numbers) */
export const ONLY_ALPHABETS = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

/**
 * Super Strong Password:
 * - At least 8 characters
 * - Must include lowercase, uppercase, number, and special character
 */
export const PASSWORD_VERY_STRONG =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

/** Numbers only */
export const NUMBERS_ONLY = /^\d+$/;

/** Numbers and decimal point */
export const NUMBERS_DOT = /^\d*\.?\d*$/;

/** Robust URL / Link pattern */
export const VALID_LINK =
  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(\/[^\s]*)?$/i;
export const URL = VALID_LINK; // Alias for backward compatibility

/** Alphanumeric with spaces */
export const ALPHA_NUMERIC_SPACE = /^[a-zA-Z0-9\s\-_.,!&()]+$/;

/**
 * Test helper: returns true if value matches pattern
 * @param {RegExp} pattern - from this file
 * @param {string} value
 */
export const testRegex = (pattern, value) => pattern.test((value || "").trim());
